'use strict';

var chunk3DGMDRJB_js = require('./chunk-3DGMDRJB.js');
var chunkV6YUYBTJ_js = require('./chunk-V6YUYBTJ.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var p = require('clsx');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var p__default = /*#__PURE__*/_interopDefault(p);

var S=({id:t,value:f,label:v,description:a,onChange:i,onClick:l,onKeyUp:r,placeholder:b,fullWidth:s,buttonAriaLabel:A,className:h,...g})=>{let[o,y]=react.useState(f),N=`${chunk32OAM7MJ_js.a}-input-add`,C=p__default.default(N,h,{"full-width":s,"with-description":!!a}),x=({target:n})=>{y(n.value),i&&i(n.value);},E=()=>{l&&l(o);},I=n=>{r&&n.key==="Enter"&&r(o);};return jsxRuntime.jsxs("div",{className:C,children:[jsxRuntime.jsx(chunk3DGMDRJB_js.a,{variant:"label",htmlFor:t,children:v}),a&&jsxRuntime.jsx("p",{className:"description",id:`${t}-description`,children:a}),jsxRuntime.jsxs("div",{className:p__default.default("input-wrapper",{"full-width":s}),children:[jsxRuntime.jsx("input",{className:"input",name:t,id:t,value:o,placeholder:b,onChange:x,onKeyUp:I,...g}),jsxRuntime.jsx("button",{className:"button","aria-label":A,onClick:E,id:`${t}-button`,children:jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:"add",size:"sm",fill:"#ffffff","aria-hidden":"true"})})]})]})},T=S;

exports.a = T;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-3HA7PQHZ.js.map